module.exports = __webpack_public_path__ + "img/ethdown.4837b411.svg";